export default __webpack_public_path__ + "static/media/tailor.a31c80e0.svg";